


const Shipping=()=>{
     
    return(
        <div className="container p-5">

<p>Our roasters ship orders directly from their roasting center to your home. You will receive an email confirmation once your order has been shipped. Items purchased from different roasters as part of the same order will ship separately.</p>

<p>Please note that roasters have set individual roasting schedules. In all cases, however, roasters will ship your coffee within 48 hours of confirmation of the order. From there, most coffee takes about 2-5 working days to be delivered.</p>

<p>Equipment will be shipped within 48 hours of confirmation of the order.</p>
<p>
In case your coffee does not reach you within 10 days, we will dispatch a new coffee or process full refund. We will not be able take any action before the 10-day period as we work with third-party courier partners and we have limited control once the order is dispatched. Please feel free to reach out to us at seracoffee@gmail.com for any concerns regarding your order.</p>

</div>
    )
}
export default Shipping;